import React from 'react';
import { DropdownMenu } from '@spark';

const PROVIDER_LABELS = {
    openai: 'OpenAI',
    anthropic: 'Anthropic',
};

/**
 * Reusable provider selector component for choosing between OpenAI and Anthropic.
 * @param {Object} props
 * @param {string} props.selectedProvider - Currently selected provider
 * @param {function} props.onProviderChange - Callback when provider is changed
 * @param {Array<string>} [props.providers] - Array of provider options (default: ['openai', 'anthropic'])
 */
const ProviderSelector = ({ selectedProvider, onProviderChange, providers = ['openai', 'anthropic'] }) => {
    const items = providers.map((provider) => ({
        label: PROVIDER_LABELS[provider] || provider,
    }));

    const handleSelect = (item) => {
        const provider = providers.find((p) => (PROVIDER_LABELS[p] || p) === item.label);
        if (provider) onProviderChange(provider);
    };

    return (
        <DropdownMenu
            size="small"
            showLabel={false}
            items={items}
            value={PROVIDER_LABELS[selectedProvider] || selectedProvider}
            text={PROVIDER_LABELS[selectedProvider] || selectedProvider}
            onSelect={handleSelect}
            className="docs-provider-selector"
        />
    );
};

export default ProviderSelector;
